import { useLazyGetToolResultPresignedUrlQuery } from '@saaga/shared/store/tool-result-endpoints.store'
import { type ReactNode, useMemo } from 'react'

import { createFetchPresignedUrl } from './fetch-presigned-url.helper'
import type { ToolCallContentData } from './tool-call-content.interface'
import { ToolCallContent } from './tool-call-content.molecule'
import { useToolHtmlReport } from './use-tool-html-report.hook'

export interface ToolCallContentContainerProps {
  data: ToolCallContentData
  className?: string
}

export const ToolCallContentContainer: React.FC<ToolCallContentContainerProps> = ({
  data,
  className,
}): ReactNode => {
  const [trigger] = useLazyGetToolResultPresignedUrlQuery()
  const fetchPresignedUrl = useMemo(() => createFetchPresignedUrl(trigger), [trigger])
  const htmlReport = useToolHtmlReport(data.toolCall.htmlResultKey, fetchPresignedUrl)

  return <ToolCallContent data={data} htmlReport={htmlReport} className={className} />
}
